import React from "react";
import { BaseContainer, getBackgroundColor, HEIGHT } from "./base-container";
import { Translation } from "../../../core/translate";
import { Button } from "@vitalsource/vstui";
import styled, { withTheme } from "styled-components";
import QuestionMarkAndMenu from "./question-mark-and-menu";
import { connect } from "react-redux";
import { goToTeacherPortal } from "../../../../redux/navigation/actions";

export const FOOTER_HEIGHT = HEIGHT;

const HelpContainer = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
`;

// Without this, the help button ends up in the padding of the outer container
const InnerContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const BodyContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  // To not intersect the question mark. The main content is centered in the banner with a question mark overlay on the right
  padding: 0 65px;

  p {
    margin-right: 30px;
    text-align: center;
    font-size: 1.4rem;
    line-height: 1.4;
  }
`;

function TeacherFooter({ theme, offset, goToTeacherPortal }) {
  return (
    <BaseContainer offset={offset}>
      <InnerContainer>
        <BodyContainer>
          <p>
            <Translation id="teacher-portal.teacher-portal-desc" />
          </p>
          <Button
            color="white"
            colorBehindButton={getBackgroundColor(theme)}
            onClick={goToTeacherPortal}
          >
            <Translation id="teacher-portal.go-to-teacher-portal" />
          </Button>
        </BodyContainer>
        <HelpContainer>
          <QuestionMarkAndMenu />
        </HelpContainer>
      </InnerContainer>
    </BaseContainer>
  );
}

export default connect(
  null,
  dispatch => ({
    goToTeacherPortal: () => dispatch(goToTeacherPortal())
  })
)(withTheme(TeacherFooter));
